import dayjs from 'dayjs';
import printJS from 'print-js';
import pdfMake from 'pdfmake/build/pdfmake.js';

import { vfs } from 'documents/vfs';
import { centimetersToPoints } from 'documents/constants';

export const certificateHigh = (parameters, student) => {
	const document = {
		pageOrientation: 'landscape',
		pageSize: 'A4',
		pageMargins: [470, centimetersToPoints(4.4), 40, 0],
		defaultStyle: {
	    lineHeight: 1.4,
			fontSize: 12,
			font: 'Times'
		},
		content: [
			// Students information
			{ text: `${student.name} ${student.surname}`, alignment: 'center', bold: true, fontSize: 18, margin: [0, 35, 0, 0] },
			{ text: `personas kods ${student.personalCode}`, alignment: 'center' },
			{ text: 'Rīgas Tālmācības vidusskolā', alignment: 'center', bold: true },
			{ text: `${dayjs(student.certificate.issueDate).format('YYYY')}. gadā ieguva vispārējo vidējo izglītību`, alignment: 'center' },

			// Signatures
			{
				margin: [25, 80, 0, 0],
				columns: [
					{
						width: '65%',
						text: 'Direktors',
						// text: 'Direktora p.i.'
					},
					{
						width: '*',
						text: 'E. Grīnis'
						// text: 'I. Lazda'
					}
				]
			},
			{
				margin: [25, 20, 0, 0],
				columns: [
					{
						width: '65%',
						text: 'Pedagogi:'
					},
					[
						{ text: student.certificate.teacherOneName },
						{ text: student.certificate.teacherTwoName }
					]
				]
			},

			// Date and place stamps
			{ text: 'Atestāts izsniegts', margin: [0, 40, 0, 0] },
			{ text: dayjs(student.certificate.issueDate).format('ll') },
			{ text: 'Rīgā, Latvijā' },
			{ text: 'Z.v.' }
		]
	};

	// Append vfs with custom config
	pdfMake.vfs = vfs;

	// Append custom fonts
	pdfMake.fonts = {
		Times: {
			normal: 'Times-Regular.ttf',
			bold: 'Times-Bold.ttf'
		}
	};

	// Download pdf
	if (parameters.action === 'download') pdfMake.createPdf(document).download(`atestats-${student.name}-${student.surname}.pdf`);

	// Open print dialogue
	if (parameters.action === 'print') pdfMake.createPdf(document).getBase64(base64 => printJS({
		printable: base64,
		base64: true,
		type: 'pdf'
	}));
};